export default __webpack_public_path__ + "static/top-developers-1fd212b71f0bd9ca57f90f1c9479dcda.png";